import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import styles from "./Navbar.module.css";

const WHATSAPP_NUMBER = "971567575811";

function Navbar() {
  const { totalCount } = useCart();

  const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi Tripontourism! I'd like to book a Desert Safari."
  )}`;

  return (
    <nav className={`${styles.navbar} navbar navbar-expand-md`}>
      <div className="container-fluid d-flex align-items-center justify-content-between">
        <Link to="/" className={styles.brand} aria-label="Back to homepage">
          <div className={styles.logoCircle}>
            <span role="img" aria-label="jeep">
              🚙
            </span>
          </div>
          <span className={styles.brandText}>Tripontourism</span>
        </Link>

        <div className={styles.rightGroup}>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.whatsappBtn}
          >
            <span aria-hidden="true">💬</span>
            <span className={styles.whatsappLabel}>+971 56 757 5811</span>
          </a>

          <Link to="/cart" className={styles.cartLink} aria-label="View cart">
            <span aria-hidden="true">🛒</span>
            {totalCount > 0 && (
              <span className={styles.cartBadge}>{totalCount}</span>
            )}
          </Link>

          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.bookBtn}
          >
            Book Now
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
